import request from '@/utils/request/request'

export function academic_year(data) {
  return request({
    url: '/v1/academic_year',
    method: 'get',
    data
  })
}

export function webcourses(data) {
  return request({
    url: '/v1/webcourses',
    method: 'get',
    data
  })
}

export function get_course_type(data) {
    return request({
      url: '/v1/get_course_type',
      method: 'get',
      data
    })
  }

export function signup_once(data) {
    return request({
      url: '/v1/signup_once',
      method: 'get',
      data
    })
  }

  export function mycourses(data) {
    return request({
      url: '/v1/mycourses',
      method: 'get',
      data
    })
  }


  export function validate(data) {
    return request({
      url: '/v1/validate',
      method: 'get',
      data
    })
  }

  export function webcourse_detail(data) {
    return request({
      url: '/v1/webcourse_detail',
      method: 'get',
      data
    })
  }


  export function records(data) {
    return request({
      url: '/v1/records',
      method: 'post',
      data
    })
  }


  export function course_evaluate(data) {
    return request({
      url: '/v1/pushgrade',
      method: 'post',
      data
    })
  }

  export function course_last(data) {
    return request({
      url: '/v1/checkstucourse',
      method: 'get',
      data
    })
  }

    // 我的公需课-获取学年
    export function public_courses_year(data) {
      return request({
        url: '/v1/public_courses_year',
        method: 'get',
        data
      })
    }
  // 我的公需课列表
  export function public_courses_my(data) {
    return request({
      url: '/v1/public_courses_my',
      method: 'get',
      data
    })
  }

    // 全部公需课列表
    export function public_courses_list(data) {
      return request({
        url: '/v1/public_courses_list',
        method: 'get',
        data
      })
    }
     // 我的公需课-报名
     export function public_courses_signup_once(data) {
      return request({
        url: '/v1/public_courses_signup_once',
        method: 'post',
        data
      })
    }
    // 公需课详情
    export function public_courses_detail(data) {
      return request({
        url: '/v1/public_courses_detail',
        method: 'get',
        data
      })
    }

    // 公需课上报学习进度
    export function public_courses_recordProgress(data) {
      return request({
        url: '/v1/public_courses_recordProgress',
        method: 'post',
        data
      })
    }

    // 公需课人脸识别
    export function public_courses_facecompare(data) {
      return request({
        url: '/v1/public_courses_facecompare',
        method: 'post',
        data
      })
    }

    // 公需课评价是否最后一课
    export function checkPubliccourse(data) {
      return request({
        url: '/v1/public_courses_checkPubliccourse',
        method: 'get',
        data
      })
    }

    // 公需课试题列表
    export function public_courses_examList(data) {
      return request({
        url: '/v1/public_courses_examList',
        method: 'post',
        data
      })
    }

    // 公需课答题结果
    export function public_courses_examResult(data) {
      return request({
        url: '/v1/public_courses_examResult',
        method: 'post',
        data
      })
    }


















// WEBPACK FOOTER //
// ./src/api/course.js